import { User } from "../types/access";
import { AccessActionTypes, AccessManagementAction } from "../types/actions";

const initialState: {
    users: User[];
} = {
    users: [],
};

const accessReducer = (
    state = initialState,
    action: AccessActionTypes
): typeof initialState => {
    switch (action.type) {
        case AccessManagementAction.SET_USERS:
            return {
                ...state,
                users: action.users,
            };
        default:
            return state;
    }
};

export default accessReducer;
